module.exports = __webpack_public_path__ + "static/media/pilot-ready-logo.53f2df94.png";